import React from 'react'

const React_Coding_Practice_27 = () => {
  return (
    <div>
      <h1>Coding Pratice 27</h1>
    </div>
  )
}

export default React_Coding_Practice_27
